import { Memorial, MemorialOverview } from "@models/Memorial";
import { UpcomingService } from "@models/UpcomingService";
import { Service } from "@models/Service";
import { Tribute } from "@models/Tribute";
import { GuestBookEntry } from "@models/GuestBook";
import { parseDateString } from "./string";

export function transformGuestBook(data: GuestBookEntry[]): GuestBookEntry[] {
    return data.map((entry) => ({
        ...entry,
        // @ts-expect-error TS2339
        id: entry._id,
        timestamp: parseDateString(entry.timestamp as unknown as string) as Date,
    }));
}

export function transformTributes(data: Tribute[]): Tribute[] {
    return data.map((tribute) => ({
        ...tribute,
        // @ts-expect-error TS2339
        id: tribute._id,
        timestamp: parseDateString(tribute.timestamp as unknown as string) as Date,
    }));
}

export function transformMemorialOverview(data: MemorialOverview): MemorialOverview {
    return {
        ...data,
        birthDate: parseDateString(data.birthDate as unknown as string) as Date,
        deathDate: parseDateString(data.deathDate as unknown as string) as Date,
    };
}

export function transformMemorial(data: Memorial): Memorial {
    return {
        ...data,
        birthDate: parseDateString(data.birthDate as unknown as string) as Date,
        deathDate: parseDateString(data.deathDate as unknown as string) as Date,
        serviceDateTime: parseDateString(data.serviceDateTime as unknown as string) as Date,
        timeline: data.timeline.map((elem) => ({
            ...elem,
            // @ts-expect-error TS2339
            id: elem._id,
        })),
        gallery: data.gallery.map((elem) => ({
            ...elem,
            // @ts-expect-error TS2339
            id: elem._id,
        })),
        tributes: transformTributes(data.tributes),
        guestBook: transformGuestBook(data.guestBook),
    };
}

export function transformService(service: Service): Service {
    return {
        ...service,
        dateTime: parseDateString(service.dateTime as unknown as string),
    };
}

export function transformUpcomingService(data: UpcomingService): UpcomingService {
    return {
        ...data,
        birthDate: parseDateString(data.birthDate as unknown as string) as Date,
        deathDate: parseDateString(data.deathDate as unknown as string) as Date,
        services: data.services.map(transformService),
    };
}
